import {
    hasActiveImporterError,
    hasActiveImporterErrors,
} from "@common/helpers/financialDocument";
import {
    FinancialDocumentExtended,
    ImporterErrors,
} from "@common/types/financialDocument";
import { isAccrualRowReadyForImport } from "./accrualImporter.helpers";
import { financialDocumentsForDraftSelection } from "./accrualImporterDraftGroups";
import {
    AccrualImporterDocumentRow,
    AccrualImporterViewRow,
} from "./accrualImporter.types";

export function isAccrualRowEligibleForBulkConfirm(
    row: AccrualImporterDocumentRow,
): boolean {
    const financialDocument = row.financialDocument;
    if (!financialDocument) {
        return false;
    }
    if (
        hasActiveImporterError({
            document: financialDocument,
            error: ImporterErrors.ACCRUAL_POSSIBLE_DUPLICATE,
        })
    ) {
        return false;
    }
    return isAccrualRowReadyForImport(row);
}

export function hasUnconfirmedAccrualCounterparty(document: {
    importerErrors?: ImporterErrors[] | null;
    dismissedImporterErrors?: ImporterErrors[] | null;
}): boolean {
    return hasActiveImporterError({
        document,
        error: ImporterErrors.ACCRUAL_UNCONFIRMED_COUNTERPARTY,
    });
}

export function countAccrualRowsWithImporterIssues({
    rows,
    ignoredErrors,
}: {
    rows: Array<{ financialDocument?: FinancialDocumentExtended }>;
    ignoredErrors: ImporterErrors[];
}): number {
    return rows.filter(
        (row) =>
            row.financialDocument != null &&
            hasActiveImporterErrors({
                document: row.financialDocument,
                ignoredErrors,
            }),
    ).length;
}

export function confirmableDocumentsForSelection(
    selectedRows: AccrualImporterViewRow[],
): FinancialDocumentExtended[] {
    const hasBlockedRows =
        countAccrualRowsWithImporterIssues({
            rows: selectedRows,
            ignoredErrors: [],
        }) > 0;
    if (hasBlockedRows) {
        return [];
    }
    return financialDocumentsForDraftSelection(
        selectedRows.filter((row) =>
            isAccrualRowEligibleForBulkConfirm({
                id: row.id,
                file: row.file,
                financialDocument: row.financialDocument,
            }),
        ),
    );
}
